module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_9016.c59ed2e0.png";